(() => {
  function init(root) {
    if (root.dataset.vgReady) return;
    root.dataset.vgReady = 'true';
    const message = (key, fallback, values = {}) => (root.dataset[key] || fallback).replace(/\{\{\s*(\w+)\s*\}\}|__(\w+)__/g, (_, braceName, markerName) => values[braceName || markerName] ?? '');
    const sort = root.querySelector('[data-vg-sort]');
    sort?.addEventListener('change', () => sort.form.requestSubmit());

    const form = root.querySelector('[data-vg-filter-form]');
    const minimum = form?.querySelector('[data-vg-price-min]');
    const maximum = form?.querySelector('[data-vg-price-max]');
    function validatePrice() {
      if (!minimum || !maximum) return;
      const reversed = minimum.value !== '' && maximum.value !== '' && Number(minimum.value) > Number(maximum.value);
      maximum.setCustomValidity(reversed ? message('priceError', 'The maximum price must be greater than the minimum price.') : '');
    }
    minimum?.addEventListener('input', validatePrice);
    maximum?.addEventListener('input', validatePrice);
    form?.addEventListener('formdata', event => {
      form.querySelectorAll('input[type="number"]').forEach(input => {
        if (input.value === '') event.formData.delete(input.name);
      });
    });

    let loading = false;
    root.addEventListener('click', async event => {
      const link = event.target.closest('[data-vg-load-more]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (loading) return;
      loading = true;
      link.setAttribute('aria-disabled', 'true');
      link.textContent = message('loading', 'Loading');
      const status = root.querySelector('[data-vg-load-status]');
      const grid = root.querySelector('[data-vg-collection-grid]');
      status.textContent = '';
      grid.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(link.href);
        url.searchParams.set('section_id', root.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const products = page.querySelector('[data-vg-collection-grid]');
        const pagination = page.querySelector('[data-vg-pagination]');
        if (!products || !pagination) throw new Error('Collection missing');
        const firstNew = products.querySelector('a');
        grid.append(...products.children);
        root.querySelector('[data-vg-pagination]').replaceWith(pagination);
        const progress = root.querySelector('[data-vg-progress]');
        if (progress) progress.textContent = message('progress', '{{ shown }} of {{ total }} designs', { shown: grid.querySelectorAll('[data-vg-product]').length, total: progress.dataset.total });
        document.dispatchEvent(new CustomEvent('vg:content:updated'));
        root.querySelector('[data-vg-load-status]').textContent = message('loaded', 'More designs loaded.');
        if (firstNew) firstNew.focus({ preventScroll: true });
      } catch (_) {
        status.textContent = message('loadError', 'Unable to load more designs. Please try again.');
        link.textContent = message('loadMore', 'Load more');
        link.removeAttribute('aria-disabled');
      } finally {
        loading = false;
        grid.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-vg-collection]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-vg-collection]').forEach(init);
  });
})();
